import Mutations from '../../odata/mutations';

export default { ...new Mutations('purchaseLimit'), ...new Mutations('purchaseLimits') };
